export const TEST_IDS = {
  modal: 'sd-option-modal',
  getApprovalCheckbox: 'get-approval-checkbox',
  cancelButton: 'sd-option-modal-cancel',
  submitButton: 'sd-option-modal-submit',
}
